import { simpleSet } from '@r/reducers/utils';
import { px } from 'decl/general/units';

const setY = simpleSet as redux.reducers.modals.object3dModal.y;

export const y = setY( 'SET_OBJECT_3D_MODAL_Y', 0 as px );
